import React from 'react';

import * as Types from './Types';

const Player = (props) => {
    return React.createElement(Types[props.type], props);
};

export { Player };
